import { render, staticRenderFns } from "./LoginLayout.vue?vue&type=template&id=1649d4a7&scoped=true&"
import script from "./LoginLayout.vue?vue&type=script&lang=ts&"
export * from "./LoginLayout.vue?vue&type=script&lang=ts&"
import style0 from "./LoginLayout.vue?vue&type=style&index=0&id=1649d4a7&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1649d4a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VApp,VCol,VContainer,VFooter,VRow})
